import { render, staticRenderFns } from "./DocumentForms.vue?vue&type=template&id=2bf641d6&scoped=true&"
import script from "./DocumentForms.vue?vue&type=script&lang=js&"
export * from "./DocumentForms.vue?vue&type=script&lang=js&"
import style0 from "./DocumentForms.vue?vue&type=style&index=0&id=2bf641d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf641d6",
  null
  
)

export default component.exports